import { Injectable } from '@angular/core';
import { GLOBAL } from './global.service';
import { UserService } from './user.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ParlacenTV } from '../models/parlacen-tv.model';


@Injectable({
  providedIn: 'root'
})
export class ParlacenTvService {
  private url: string;
  private contType = {
    h: 'Content-Type',
    b: 'application/json',
  }
  private auth = {
    h: 'Authorization',
    b: '',
  }

  constructor(private _http: HttpClient, userService: UserService) {
    this.url    = GLOBAL.API.url;
    this.auth.b = userService.getToken();
  }

  getVideosForAdmin: () => Observable<any> = () => {
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b);
    return this._http.get(`${this.url}parlacen-tv`, { headers });
  }

  addVideo: (video: ParlacenTV) => Observable<any> = video => {
    let params = JSON.stringify(video);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.post(`${this.url}admin/parlacen-tv`, params, { headers });
  }

  deleteVideo: (docId: string) => Observable<any> = newsId => {
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.delete(`${this.url}admin/parlacen-tv/${newsId}`, { headers });
  }

  updateVideo: (video: ParlacenTV) => Observable<any> = video => {
    let params = JSON.stringify(video);
    let headers = new HttpHeaders().set(this.contType.h, this.contType.b).set(this.auth.h, this.auth.b);
    return this._http.put(`${this.url}admin/parlacen-tv/${video.id}`, params, { headers });
  }
}
